import React from 'react';
import {
  UploadMediaToReadingPanel,
  UploadMediaToReadingPanelProps,
} from './UploadMediaToReadingPanel';
import ButtonShowPanel from 'components/base/panel/buttonshowpanel';
import { t, Trans } from '@lingui/macro';
import { ButtonProps } from 'components/base/button/button';

export const ButtonUploadMediaToReadingPanel = (
  props: Omit<UploadMediaToReadingPanelProps, 'hidePanel'> & {
    panelRef?: React.RefObject<HTMLElement>;
    buttonProps?: ButtonProps;
  }
) => {
  const { buttonProps, panelRef, ...uploadMediaToReadingPanelProps } = props;
  return (
    <ButtonShowPanel
      iconType="icon-upload"
      name="upload-media-to-reading-panel"
      title={t`Upload media`}
      panelContent={({ hidePanel }) => (
        <UploadMediaToReadingPanel
          {...uploadMediaToReadingPanelProps}
          hidePanel={hidePanel}
        />
      )}
      panelRef={props.panelRef}
      {...buttonProps}
    >
      <Trans>Upload media to reading</Trans>
    </ButtonShowPanel>
  );
};
